import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {UserModel} from '../../models/authentication/user.model';
import {StringExtensionModel} from '../../models/extensions/string-extension.model';
import {NavigationModel} from '../../models/localization-and-pricing/navigation.model';

@Component({
  selector: 'app-land-nav-header',
  templateUrl: './land-nav-header.component.html',
  styleUrls: ['./land-nav-header.component.css']
})
export class LandNavHeaderComponent implements OnInit {

  @Input() onlyIcon: Boolean = false;
  @Output() startedClicked = new EventEmitter<void>();

  constructor(private router: Router) { }

  ngOnInit() {
  }

  buttonTitle(): string {

    if (UserModel.isLoggedIn()) {

      return 'header.dashboard';
    }

    return 'header.getStarted';
  }

  navigateHome() {

    this.router.navigate(NavigationModel.getHomeURLPaths(['landing']));

  }

  getStartedClicked() {
    this.startedClicked.emit();
  }

}
